import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { House, Compass, Trophy, Rocket, UsersThree } from "@phosphor-icons/react";

const TABS = [
  { to: "/home", label: "Home", icon: House, id: "tab-home" },
  { to: "/mentors", label: "Mentors", icon: Compass, id: "tab-mentors" },
  { to: "/play", label: "Play", icon: Trophy, id: "tab-play" },
  { to: "/build", label: "Build", icon: Rocket, id: "tab-build" },
  { to: "/circles", label: "Circles", icon: UsersThree, id: "tab-circles" },
];

const HIDE_NAV = ["/", "/onboarding", "/chat"];

export const Shell = ({ children }) => {
  const loc = useLocation();
  const hide = HIDE_NAV.some((p) => p === "/" ? loc.pathname === "/" : loc.pathname.startsWith(p));
  return (
    <div className="relative mx-auto max-w-md min-h-screen bg-[#050505] text-white overflow-hidden">
      {children}
      {!hide && (
        <nav
          data-testid="bottom-nav"
          className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[92%] max-w-[420px]"
        >
          <div className="glass-strong rounded-full px-2 py-2 flex items-center justify-between shadow-[0_8px_40px_rgba(0,0,0,0.6)]">
            {TABS.map((t) => {
              const active = loc.pathname === t.to || loc.pathname.startsWith(t.to + "/");
              return (
                <NavLink
                  key={t.to}
                  to={t.to}
                  data-testid={t.id}
                  className={`flex-1 flex flex-col items-center gap-0.5 py-2 rounded-full transition-all ${
                    active ? "bg-white text-black" : "text-zinc-400"
                  }`}
                >
                  <t.icon size={20} weight={active ? "fill" : "regular"} />
                  <span className="text-[10px] tracking-wide font-medium">{t.label}</span>
                </NavLink>
              );
            })}
          </div>
        </nav>
      )}
    </div>
  );
};
